import { normalizePaymentOrder } from "./checkout";
import { expectedPaymentOrder } from "../lib/embedded-payment";
import type { Order } from "../types";

const record = (value: unknown): Record<string, unknown> | null => value !== null && typeof value === "object" && !Array.isArray(value) ? value as Record<string, unknown> : null;
const id = (value: unknown): value is string => typeof value === "string" && /^[a-f0-9]{32}$/.test(value);

export function normalizePaymentReviews(value: unknown): Order[] {
  const envelope = record(value);
  if (!envelope || !Array.isArray(envelope.items) || envelope.items.length > 100) throw new Error("La coda dei pagamenti non è verificabile.");
  const seen = new Set<string>();
  return envelope.items.map((entry: unknown) => {
    const raw = record(entry);
    if (!raw || !id(raw.id) || !id(raw.buyerId) || !id(raw.sellerId) || !id(raw.listingId)
      || raw.status !== "payment_review" || seen.has(raw.id) || typeof raw.totalCents !== "number" || raw.totalCents <= 0) {
      throw new Error("La coda contiene un ordine non verificabile. Nessuna azione è stata eseguita.");
    }
    seen.add(raw.id);
    return normalizePaymentOrder(raw, { orderId: raw.id, buyerId: raw.buyerId, sellerId: raw.sellerId, listingId: raw.listingId, totalCents: raw.totalCents });
  });
}

export function normalizePaymentRecheck(value: unknown, expected: Order): { order: Order; released: boolean } {
  const envelope = record(value);
  if (!envelope || typeof envelope.released !== "boolean") throw new Error("La verifica non ha restituito una conferma valida. Aggiorna la coda prima di riprovare.");
  const order = normalizePaymentOrder(envelope.order, expectedPaymentOrder(expected));
  if (envelope.released && order.status !== "cancelled") throw new Error("L’annullamento dell’ordine non è stato confermato. Non considerare l’articolo nuovamente disponibile.");
  return { order, released: envelope.released };
}

export function paymentReviewNotice(order: Order, released: boolean) {
  return released ? "Il servizio di pagamento ha confermato l’annullamento. Il server ha liberato la prenotazione; nessun nuovo addebito è stato richiesto."
    : order.status === "payment_review" ? "Il pagamento rimane in verifica e l’articolo resta prenotato. Non richiedere un altro pagamento e non autorizzare la spedizione. Nessun addebito, annullamento o trasferimento è stato avviato."
    : "Lo stato dell’ordine è stato aggiornato dal server. Non è stata richiesta alcuna operazione sui fondi: controlla lo stato indicato prima di procedere.";
}
